import { render, staticRenderFns } from "./BuildAKeyboard.vue?vue&type=template&id=fb0d7cea&scoped=true&"
import script from "./BuildAKeyboard.vue?vue&type=script&lang=js&"
export * from "./BuildAKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./BuildAKeyboard.vue?vue&type=style&index=0&id=fb0d7cea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0d7cea",
  null
  
)

export default component.exports